import script from "./DecorationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecorationCard.vue?vue&type=script&setup=true&lang=ts"

import "./DecorationCard.vue?vue&type=style&index=0&id=219f6a4b&lang=css"

const __exports__ = script;

export default __exports__